import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box,Typography} from '@mui/material';
import FieldView from 'core/components/layout/FieldView';
import {setPmorderSorting} from 'store/slice/PharmaSlice';

export default function PmorderListTableHeader(){
  const dispatch = useDispatch();
  const {sorting} = useSelector((state) => state.pharmaslice.pmorderDashboard);
  
  const handleColumnClick = (column) => {
  const currentSorting = sorting.column === column ? !sorting.asc : true;
    dispatch(setPmorderSorting({ column, asc: currentSorting }));     
  }
    return (
      
      <Grid container direction="row" sx={{ justifyContent: "flex-start", alignItems: "center", width: '100%', padding: 1, backgroundColor: 'primary.lighter' }}>

            {/* <HEADER - CELLS/> */}
        
                        <Grid item lg={2} xs={4} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('title')}> Material </Typography></Grid>
                         {/* <Grid item lg={2} xs={4} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('pmstatus')}>Req. Qty </Typography></Grid> */}
                        <Grid item lg={2} xs={4} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('pmstatus')}>Avail. Qty </Typography></Grid>
                        <Grid item lg={2} xs={4} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('pmstatus')}>Ordered Qty </Typography></Grid>
                        <Grid item lg={2} xs={4} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('pmstatus')}>Vendor Name </Typography></Grid>

      </Grid>
      
    )
}